import * as React from 'react';
import type { FetchResult } from 'react-apollo';
import { Mutation } from 'react-apollo';

import gql from 'graphql-tag';

import type {
  DismissCalendarItemRequest,
  DismissCalendarItemResponse,
} from '@coursera/grpc-types-degreehome/coursera/proto/degreehome/v1beta1/degree_home_calendar_api';

/* eslint-disable graphql/template-strings */
export const dismissCalendarItemMutation = gql`
  mutation DismissCalendarItem($input: DataMap!) {
    DismissCalendarItem(input: $input)
      @rest(
        type: "DismissCalendarItem"
        path: "grpc/degreehome/v1beta1/DegreeHomeCalendarAPI/DismissCalendarItem"
        method: "POST"
      ) {
      calendarItem
    }
  }
`;
/* eslint-enable */

type MutationProps = {
  input: DismissCalendarItemRequest;
};

type DismissAction = () => Promise<void | FetchResult<DismissCalendarItemResponse>>;

type InputProps = {
  userId: number;
  degreeId: string;
  courseId: string;
  itemId: string;
};

export type DismissCalendarItemMutationProps = InputProps & {
  children: (
    x0: {
      dismissAction: DismissAction;
    },
    { loading }: { loading: boolean }
  ) => React.ReactElement | null;
};

export const WithDismissCalendarItemMutation = ({
  children,
  userId,
  degreeId,
  courseId,
  itemId,
}: DismissCalendarItemMutationProps) => {
  return (
    <Mutation<DismissCalendarItemResponse, MutationProps> mutation={dismissCalendarItemMutation}>
      {(dismissActionMutation, { loading }) => {
        const dismissAction = () => {
          return dismissActionMutation({
            variables: {
              input: {
                userId,
                degreeId,
                courseId,
                itemId,
              },
            },
          });
        };
        return children({ dismissAction }, { loading });
      }}
    </Mutation>
  );
};

export default WithDismissCalendarItemMutation;
